import { useCallback } from 'react';
import { useServices } from './useServices';

/**
 * A function returning the current undo-history version at call time. Used right after a command
 * completes, to tie a toast's undo button to exactly that command.
 */
export function useUndoVersionReader(): () => number {
  const { undo } = useServices();
  return useCallback(() => undo.getSnapshot().version, [undo]);
}
